<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    window.addEventListener('unload', (e) => this.unloadFn());
  },
  methods: {
    // 将 vuex 存入本地
    unloadFn() {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state));
    },
  },
  destroyed() {
    window.removeEventListener('unload', (e) => this.unloadFn());
  },
};
</script>

<style lang="less">
#app {
  padding: 0px;
  font-family: 'PingFang SC', 'Regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 0.04em;
  font-style: normal;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 设置为透明 */
}

body {
  margin: 0px;
  padding: 0;
}

html,
body {
  background-color: #fff;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}
</style>
